import React, { ReactElement } from "react";
import { useAuth } from "../../context/AuthContext";
import { InternalUserRoles, Role } from "../../constants/roles";
import { PageUnauthorized } from "../../pages/status/PageUnauthorized";

interface AuthGateProps {
  restrictedToRoles?: Role[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const AuthGate = ({
  restrictedToRoles = InternalUserRoles,
  fallback = <></>,
  children,
}: AuthGateProps): ReactElement => {
  const { isAuthenticated, hasAnyRole } = useAuth();

  if (isAuthenticated === undefined || isAuthenticated === null) {
    return <LoadingAuth />;
  } else if (isAuthenticated === false) {
    return <PageUnauthorized />;
  }

  const hasAccess =
    !restrictedToRoles || restrictedToRoles.length === 0 || hasAnyRole(restrictedToRoles);

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

const LoadingAuth = () => {
  return (
    <div style={{ textAlign: "center", padding: "10px" }}>
      <p>Loading...</p>
    </div>
  );
};

export default AuthGate;
